import { memo } from 'react';
import { init, SearchIndex } from 'emoji-mart';
import data from '@emoji-mart/data';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'em-emoji': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > & {
        id?: string;
        shortcodes?: string;
        native?: string;
        size?: string | number;
        fallback?: string;
        set?: 'native' | 'apple' | 'facebook' | 'google' | 'twitter';
        skin?: string | number;
      };
    }
  }
}

interface Props {
  name: string | null;
  size?: number;
  className?: string;
}

init({ data });

export async function nativeStringByName(name: string) {
  const emojis: any = await SearchIndex.search(name);
  if (!emojis || !emojis[0].id) return null;
  return `:${emojis[0].id}:`;
}

const Component = memo((props: Props) => {
  if (!props.name) return null;
  return <em-emoji id={props.name} size={props.size || 18}></em-emoji>;
});

export default Component;
